var _rect, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReturns(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D8D8D8",
    fillOpacity: 0.01
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.48005 9.20798C7.81383 9.07447 8.18617 9.07447 8.51995 9.20798L15 11.8L8 14.6L1 11.8L7.48005 9.20798Z",
    fill: "#C3B9D2",
    fillOpacity: 0.16,
    stroke: "#C3B9D2",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 11.8L8 14.6V23L1 20.2V11.8Z",
    stroke: "#C3B9D2",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 14.6L15 11.8015V20.2L8 23V14.6Z",
    stroke: "#C3B9D2",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11 3.5V2.5H21C22.3807 2.5 23.5 3.61929 23.5 5V14C23.5 15.3807 22.3807 16.5 21 16.5H15V15.5H21C21.8284 15.5 22.5 14.8284 22.5 14V5C22.5 4.17157 21.8284 3.5 21 3.5H11Z",
    fill: "#C3B9D2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.8364 4.78858C12.9145 4.71048 12.9145 4.58384 12.8364 4.50574L11.8314 3.50071L16.4243 3.50071C16.5347 3.50071 16.6243 3.41117 16.6243 3.30071V2.70071C16.6243 2.59026 16.5347 2.50071 16.4243 2.50071L11.8314 2.50071L12.8364 1.49569C12.9145 1.41758 12.9145 1.29095 12.8364 1.21284L12.4121 0.788581C12.334 0.710476 12.2074 0.710476 12.1293 0.788581L10.0586 2.85929C9.98047 2.9374 9.98047 3.06403 10.0586 3.14213L12.1293 5.21284C12.2074 5.29095 12.334 5.29095 12.4121 5.21284L12.8364 4.78858Z",
    fill: "#C3B9D2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReturns);
export default __webpack_public_path__ + "static/media/returns.e30e0b9f38e529ff37c8e9183c33a377.svg";
export { ForwardRef as ReactComponent };